import {css} from 'lit';
export const styles = css`:host {
  --tab-color: var(--body-text);
  --tab-color-hover: var(--primary-300);
  --tab-color-active: var(--primary-500);
  --link-text: var(--tab-color);
  --link-text-hover: var(--tab-color-hover);
  --link-text-active: var(--tab-color-active);

  cursor: pointer;
}

  :host .tab {
    display: flex;
    display: var(--tab-display, flex);
    justify-content: flex-start;
    justify-content: var(--tab-justify-content, flex-start);
    padding: 8px;
    padding: var(--tab-padding, 8px);
    border-radius: 0;
    border-radius: var(--tab-border-radius, 0);
    background-color: transparent;
    background-color: var(--tab-background, transparent);
    color: var(--tab-color);
    font-family: var(--font-family);
    font-family: var(--tab-font, var(--font-family));
    font-size: var(--font-size-base);
    font-size: var(--tab-font-size, var(--font-size-base));
    font-weight: 400;
    font-weight: var(--tab-font-weight, 400);
    transition: all var(--transition-timing) var(--transition-duration);
  }

  :host ::slotted(.prefix) {
    margin-right: 4px;
  }

  :host ::slotted(.suffix) {
    margin-left: 4px;
  }

:host([active]) .tab {
    color: var(--tab-color-active);
  }

@media (hover: hover) {
    :host(:hover:not([disabled])) .tab {
      color: var(--tab-color-hover);
    }
}

:host(:active:not([disabled])) .tab {
    color: var(--tab-color-active);
  }
`;
export default styles;
